import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplacePipe } from '@core/pipes/replace/replace.pipe';
import { HexToRgbPipe } from './hex-to-rgb/hex-to-rgb.pipe';
import { CurrencyPipe } from './currency/currency.pipe';
import { SafeHtmlPipe } from '@core/pipes/safe-html/safe-html.pipe';

@NgModule({
	declarations: [ReplacePipe, HexToRgbPipe, CurrencyPipe, SafeHtmlPipe],
	imports: [CommonModule],
	exports: [ReplacePipe, HexToRgbPipe, SafeHtmlPipe],
})
export class PipesModule {}
